export default __webpack_public_path__ + "static/media/home1.2f41e386.svg";